import React, { useState } from 'react';
import {
  Input,
  Button,
  FormItem
} from '@mayo/mayo-ui-gakki';
import SubHeader from '@gakki/components/SubHeader';
import {ReactComponent as RedoIcon} from 'app/gakki/assets/redo.svg';
import {ReactComponent as CloseIcon} from '@common/assets/icon_times.svg';
import { Panel, Tags } from './common';
import {
  ResetDialog,
  ResetSuccessDialog,
} from '@gakki/components/Dialog';

type JobTitleFormProps = {
  jobTitles: string[];
  setJobTitles: (jobTitles: string[]) => void;
}
export default function JobTitleForm(props: JobTitleFormProps) {
  const {
    jobTitles,
    setJobTitles,
  } = props;
  const [inputValue, setInputValue] = useState(''); 
  const [errorMessage, setErrorMessage] = useState('');
  const [showResetDialog, setShowResetDialog] = useState(false);
  const [showResetSuccessDialog, setShowResetSuccessDialog] = useState(false);

  const handleAdd = () => {
    const isRepeat = jobTitles.find(s => s === inputValue);
    if (inputValue && !isRepeat) {
      const newData = [...jobTitles, inputValue];
      setJobTitles(newData);
      setInputValue('');
      setErrorMessage('');
    } else {
      if (isRepeat) {
        return setErrorMessage('職稱不可相同');
      }
    }
  };

  const handleRemove = (i: number) => {
    const newData = [...jobTitles.slice(0, i), ...jobTitles.slice(i + 1, jobTitles.length)];
    setJobTitles(newData);
  };

  const handleReset = () => {
    setJobTitles([]);
    setShowResetDialog(false);
    setShowResetSuccessDialog(true);
  }
  return (
    <Panel>
      <SubHeader className={'!h-[66.3px] !m-0'}>
        新增職稱
      </SubHeader>
      <div className={'grid grid-cols-[1fr,auto] gap-[15px] py-5'}>
        <FormItem errorMessage={Boolean(errorMessage) ? errorMessage : ''}>
          <Input
            onChange={e => {
              setInputValue(e.currentTarget?.value)
              if (!e.currentTarget?.value) {
                setErrorMessage('');
              }
            }}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                e.stopPropagation();
                handleAdd();
              }
            }}
            value={inputValue}
            isError={Boolean(errorMessage)}
            placeholder="請輸入職稱"
            data-test-id={'job-title-input'}
          />
        </FormItem>
        <Button
          aria-label='add-job-title'
          variant={'solid'}
          colorSchema={'primary'}
          onClick={handleAdd}
          className={'add-btn whitespace-nowrap'}
        >
          新增
        </Button>
      </div>
      <div className="flex justify-between items-center mb-[5px]">
        <div>員工職稱</div>
        {jobTitles.length > 0 &&
          <Button
            variant={'simple'}
            colorSchema={'primary'}
            onClick={() => setShowResetDialog(true)}
            aria-label="reset-job-title"
            icon={<RedoIcon/>}
          >
            全部重設
          </Button>
        }
      </div>
      <div className="-ml-[5px]">
        {jobTitles.map((title, i) => {
          return (
            <Tags
              key={i}
              data-test-id={`job-title-${i}`}
              aria-label={`job-title-item-${i}`}
              className={'group'}
            >
              {title}
              <i
                className={`absolute h-[20px] w-[20px] flex items-center
                  justify-center cursor-pointer right-[5px]`}
                onClick={() => handleRemove(i)}
                data-test-id={`job-title-remove-btn-${i}`}
              >
                <Button
                  variant={'simple'}
                  colorSchema={'primary'}
                  icon={<CloseIcon className={'w-3 h-3 hidden group-hover:inline'}/>}
                />
              </i>
            </Tags>
          );
        })}
      </div>
      <ResetDialog
        isOpen={showResetDialog}
        onCancel={() => setShowResetDialog(false)}
        onConfirm={handleReset}
      />
      <ResetSuccessDialog
        isOpen={showResetSuccessDialog}
        onCancel={() => setShowResetSuccessDialog(false)}
      />
    </Panel>
  );
}
